const c = (w = "", o = "_blank", e) => {
  const n = window.open(w, o, e);
  return {
    navigate: (i) => {
      n ? n.location.href = i : window.open(i, o, e);
    },
    close: () => {
      n && n.close();
    },
    window: n
  };
};
export {
  c as openWindowSafely
};
